// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2fC15","row":"styles_row__1xB5-"};